module.exports = __webpack_public_path__ + "img/file--@1x.3a37d917.png";